var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50003 0.798828C8.93348 0.798828 11.2622 2.58831 12.8006 4.44734C13.0671 4.76961 13.0658 5.2355 12.8006 5.5561C12.4141 6.02317 11.6038 6.92479 10.5215 7.71258C7.78994 9.70113 5.20412 9.69675 2.47852 7.71258C1.39627 6.92479 0.585965 6.02317 0.19945 5.5561C-0.0664832 5.23488 -0.0664832 4.76856 0.19945 4.44734C1.73683 2.58956 4.06611 0.798828 6.50003 0.798828ZM9.30196 5.00172C9.30196 3.45666 8.0451 2.19979 6.50003 2.19979C4.95497 2.19979 3.69811 3.45666 3.69811 5.00172C3.69811 6.54678 4.95497 7.80365 6.50003 7.80365C8.0451 7.80365 9.30196 6.54678 9.30196 5.00172ZM8.50137 5.00172C8.50137 6.10705 7.60533 7.0031 6.5 7.0031C5.39467 7.0031 4.49862 6.10705 4.49862 5.00172C4.49862 3.89639 5.39467 3.00034 6.5 3.00034C7.60533 3.00034 8.50137 3.89639 8.50137 5.00172Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.8317f3c0.svg";
export { ForwardRef as ReactComponent };